import { render, staticRenderFns } from "./ModalEditUserPassword.vue?vue&type=template&id=1773d4dd&scoped=true&lang=pug&"
import script from "./ModalEditUserPassword.vue?vue&type=script&lang=ts&"
export * from "./ModalEditUserPassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1773d4dd",
  null
  
)

export default component.exports